module.exports = __webpack_public_path__ + "static/media/refresh-light.eb218479.svg";